/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Russell_TitleInputs */

const en_home_quotes_russell_title = /** @type {(inputs: Home_Quotes_Russell_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writer of the leading textbook on AI`)
};

/**
* | output |
* | --- |
* | "Writer of the leading textbook on AI" |
*
* @param {Home_Quotes_Russell_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_russell_title = /** @type {((inputs?: Home_Quotes_Russell_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Russell_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_russell_title(inputs)
});